<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<template>
  <button type="button" :class="btnClass" @click="wijMoExcelDownload()">{{ $t(btnLabel) }}</button>
</template>
<script>
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import * as wjcGrid from '@grapecity/wijmo.grid';
import * as wjcXlsx from '@grapecity/wijmo.xlsx';

export default {
  name: 'WijmoExcelDownload',
  data() {
    return {};
  },
  props: {
    btnLabel: {
      required: false,
      type: String,
      default: 'sdl.common.label.excelDownload',
    },
    btnClass: {
      required: false,
      type: String,
      default: 'btn btn-secondary btn-sm',
    },
    wjimoDataGrid: {
      required: false,
      type: Object,
      default: () => {},
    },
    excelName: {
      required: true,
      type: String,
      default: 'WjimoExcelDownload.xlsx',
    },
  },
  methods: {
    wijMoExcelDownload() {
      if (this.wjimoDataGrid != null) {
        wjcGridXlsx.FlexGridXlsxConverter.saveAsync(
          this.wjimoDataGrid,
          {
            includeColumnHeaders: true,
            includeStyles: false,
            formatItem: this.exportFormatItem,
          },
          this.excelName,
        );
      }
    },
    exportFormatItem(args) {
      const p = args.panel;
      const { row } = args;
      const { col } = args;
      const { xlsxCell } = args;

      if (p.cellType === wjcGrid.CellType.Cell) {
        if (p.columns[col].binding === 'color') {
          if (xlsxCell.value) {
            if (!xlsxCell.style.font) {
              xlsxCell.style.font = {};
            }
            xlsxCell.style.font.color = xlsxCell.value.toLowerCase();
          }
        } else if (p.columns[col].binding === 'active' && p.rows[row] instanceof wjcGrid.GroupRow) {
          const cell = args.getFormattedCell();
          xlsxCell.value = cell.textContent.trim();
          xlsxCell.style.hAlign = wjcXlsx.HAlign.Left;
        }
      }
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/common/control/excel/WijmoExcelDownload.vue